'use client';

import { createContext, useContext, useTransition, ReactNode } from 'react';

interface LoadingContextType {
  isPending: boolean;
  startLoadingTransition: (callback: () => void) => void;
}

const LoadingContext = createContext<LoadingContextType | undefined>(undefined);

export const LoadingProvider = ({ children }: { children: ReactNode }) => {
  const [isPending, startTransition] = useTransition();

  return (
    <LoadingContext.Provider value={{ isPending, startLoadingTransition: startTransition }}>
      {children}
    </LoadingContext.Provider>
  );
};

export const useLoading = () => {
  const context = useContext(LoadingContext);
  if (!context) {
    throw new Error('useLoading must be used within a LoadingProvider');
  }
  return context;
};
